import React from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children, allowedRoles }) {
  const userRole = localStorage.getItem("userRole");

  // If no role is stored, redirect to login
  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  // If user role is not in allowed roles, redirect to appropriate page
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Redirect based on user's actual role
    switch (userRole) {
      case "admin":
        return <Navigate to="/admin" replace />;
      case "staff":
        return <Navigate to="/staff" replace />;
      case "customer":
        return <Navigate to="/profile" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  return children;
}

export default ProtectedRoute;
